module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_purchases", [["div",{"class":"site-page favorites no-pb"},[["section",{"class":"purchases"}]]]]);
fox.registerTemplate("purchases_grid", [["div",{"class":"block background-color-1 purchases-list-page"},[["div",{"class":"pad-lr pad-tb"},[["div",{"class":"block-title global-title background-color-2 title-with-filter"},[["textNode",{"text":"My purchases"}]]],["div",{"class":"clearfix"},[["div",{"class":"items store-list-wrapper content-list clearfix grid"},[["div",{"class":"product-list"},[["div",{"class":"content-grid store-grid purchases-list"},[["div",{"class":"store-item"}]]],["div",{"class":"pager-wrapper pagination"}]]]]]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/purchases/grid.tpl
// module id = 1247
// module chunks = 4